// extracted by mini-css-extract-plugin
export default {"title":"discountList_title__841rU","discounts":"discountList_discounts__ZhqEy","emptyMsg":"discountList_emptyMsg__S+zkm"};